<div style="overflow: hidden;">
  <form [formGroup]="form">
    <fieldset>
      <legend>Layout</legend>
      <div>
        <div class="mb-3 row layout-row">
          <div class="col-lg-2">
            <input type="radio" name="layoutType" value="Radial" [checked]="layoutType.value == 'Radial'"
              [formControl]="layoutType" />
              <span class="uv-checkbox-label">Radial</span>
            </div>
            <div class="col-lg-2">
              <input type="radio" name="layoutType" value="Hierarchical" [checked]="layoutType.value == 'Hierarchical'"
                [formControl]="layoutType" />
                <span class="uv-checkbox-label">Hierarchical</span>
              </div>
              <div class="col-lg-2">
                <input type="radio" name="layoutType" value="Ring" [checked]="layoutType.value == 'Ring'"
                  [formControl]="layoutType" />
                  <span class="uv-checkbox-label">Ring</span>
                </div>
                @if (allowManualLayout) {
                  <div class="col-lg-2">
                    <input type="radio" name="layoutType" value="Manual" [checked]="layoutType.value == 'Manual'"
                      [formControl]="layoutType" />
                      <span class="uv-checkbox-label">Manual</span>
                    </div>
                  }
                </div>
              </div>
              <div [hidden]="layoutType.value != 'Radial'">
                <!-- Minimum Radius-->
                <div class="mb-3 row" [ngClass]="{'has-error':!radialMinRadius.valid}">
                  <span class="col-lg-3">Minimum Radius:</span>
                  <div class="col-lg-2">
                    <input class="form-control" type="text" [formControl]="radialMinRadius" />
                  </div>
                </div>
                @if (radialMinRadius.hasError('required')) {
                  <div class="mb-3 row">
                    <div class="col-lg-6 alert alert-danger">
                      Minimum Radius is required
                    </div>
                  </div>
                }
                @if (radialMinRadius.hasError('minValue') || radialMinRadius.hasError('maxValue')) {
                  <div
                    class="mb-3 row">
                    <div class="col-lg-6 alert alert-danger">
                      Minimum Radius must be in the range 0 - 9999
                    </div>
                  </div>
                }

                <!-- Maximum Radius -->
                <div class="mb-3 row" [ngClass]="{'has-error':!radialMaxRadius.valid}">
                  <span class="col-lg-3">Maximum Radius:</span>
                  <div class="col-lg-2">
                    <input class="form-control" type="text" [formControl]="radialMaxRadius" />
                  </div>
                </div>
                @if (radialMaxRadius.hasError('required')) {
                  <div class="mb-3">
                    <div class="col-lg-6 alert alert-danger">
                      Maximum Radius is required
                    </div>
                  </div>
                }
                @if (radialMaxRadius.hasError('minValue') || radialMaxRadius.hasError('maxValue')) {
                  <div
                    class="mb-3 row">
                    <div class="col-lg-6 alert alert-danger">
                      Maximum Radius must be in the range 0 - 9999
                    </div>
                  </div>
                }

                <!-- Maximum Angle -->
                <div class="mb-3 row" [ngClass]="{'has-error':!radialMaxAngle.valid}">
                  <span class="col-lg-3">Maximum Angle:</span>
                  <div class="col-lg-2">
                    <input class="form-control" type="text" [formControl]="radialMaxAngle" />
                  </div>
                </div>
                @if (radialMaxAngle.hasError('required')) {
                  <div class="mb-3 row">
                    <div class="col-lg-6 alert alert-danger">
                      Maximum Angle is required
                    </div>
                  </div>
                }
                @if (radialMaxAngle.hasError('minValue') || radialMaxAngle.hasError('maxValue')) {
                  <div
                    class="mb-3 row">
                    <div class="col-lg-6 alert alert-danger">
                      Maximum Angle must be in the range 0 - 999
                    </div>
                  </div>
                }
              </div>
              <div [hidden]="layoutType.value != 'Hierarchical'">
                <!-- Level Spacing -->
                <div class="mb-3 row" [ngClass]="{'has-error':!treeLevelSpacing.valid}">
                  <span class="col-lg-3">Level Spacing:</span>
                  <div class="col-lg-2">
                    <input class="form-control" type="text" [formControl]="treeLevelSpacing" />
                  </div>
                </div>
                @if (treeLevelSpacing.hasError('required')) {
                  <div class="mb-3 row">
                    <div class="col-lg-6 alert alert-danger">
                      Level Spacing is required
                    </div>
                  </div>
                }
                @if (treeLevelSpacing.hasError('minValue') || treeLevelSpacing.hasError('maxValue')) {
                  <div
                    class="mb-3 row">
                    <div class="col-lg-6 alert alert-danger">
                      Level Spacing must be in the range 0 - 9999
                    </div>
                  </div>
                }

                <!-- Node Spacing -->
                <div class="mb-3 row" [ngClass]="{'has-error':!treeNodeSpacing.valid}">
                  <span class="col-lg-3">Node Spacing:</span>
                  <div class="col-lg-2">
                    <input class="form-control" type="text" [formControl]="treeNodeSpacing" />
                  </div>
                </div>
                @if (treeNodeSpacing.hasError('required')) {
                  <div class="mb-3 row">
                    <div class="col-lg-6 alert alert-danger">
                      Node Spacing is required
                    </div>
                  </div>
                }
                @if (treeNodeSpacing.hasError('minValue') || treeNodeSpacing.hasError('maxValue')) {
                  <div
                    class="mb-3 row">
                    <div class="col-lg-6 alert alert-danger">
                      Node Spacing must be in the range 0 - 9999
                    </div>
                  </div>
                }

                <!-- Root Alignment -->
                <div class="mb-3 row">
                  <span class="col-lg-3">Root Alignment: </span>
                  <div class="col-lg-2">
                    <select class="form-control" [formControl]="treeRootAlignment">
                      <option value="Left">Left</option>
                      <option value="Center">Center</option>
                      <option value="Right">Right</option>
                    </select>
                  </div>
                </div>

                <!-- Layout Direction -->
                <div class="mb-3 row">
                  <span class="col-lg-3">Layout Direction: </span>
                  <div class="col-lg-2">
                    <select class="form-control" [formControl]="treeLayoutDirection">
                      <option value="Left">Left</option>
                      <option value="Right">Right</option>
                      <option value="Up">Up</option>
                      <option value="Down">Down</option>
                    </select>
                  </div>
                </div>

                <!-- Use Straight Links -->
                <div class="mb-3 row">
                  <input type="checkbox" style="margin-left: 15px;" [formControl]="treeUseStraightLinks" />
                  <span class="uv-checkbox-label">Use Straight Links</span>
                </div>
              </div>
              <div [hidden]="layoutType.value != 'Ring'">
                <!-- Minimum Radius-->
                <div class="mb-3 row" [ngClass]="{'has-error':!ringMinRadius.valid}">
                  <span class="col-lg-3">Minimum Radius:</span>
                  <div class="col-lg-2">
                    <input class="form-control" type="text" [formControl]="ringMinRadius" />
                  </div>
                </div>
                @if (ringMinRadius.hasError('required')) {
                  <div class="mb-3">
                    <div class="col-lg-6 alert alert-danger">
                      Minimum Radius is required
                    </div>
                  </div>
                }
                @if (ringMinRadius.hasError('minValue') || ringMinRadius.hasError('maxValue')) {
                  <div
                    class="mb-3 row">
                    <div class="col-lg-6 alert alert-danger">
                      Minimum Radius must be in the range 0 - 9999
                    </div>
                  </div>
                }

                <!-- Maximum Radius -->
                <div class="mb-3 row" [ngClass]="{'has-error':!ringMaxRadius.valid}">
                  <span class="col-lg-3">Maximum Radius:</span>
                  <div class="col-lg-2">
                    <input class="form-control" type="text" [formControl]="ringMaxRadius" />
                  </div>
                </div>
                @if (ringMaxRadius.hasError('required')) {
                  <div class="mb-3">
                    <div class="col-lg-6 alert alert-danger">
                      Maximum Radius is required
                    </div>
                  </div>
                }
                @if (ringMaxRadius.hasError('minValue') || ringMaxRadius.hasError('maxValue')) {
                  <div
                    class="mb-3 row">
                    <div class="col-lg-6 alert alert-danger">
                      Maximum Radius must be in the range 0 - 9999
                    </div>
                  </div>
                }

                <!-- Maximum Angle -->
                <div class="mb-3 row" [ngClass]="{'has-error':!ringMaxAngle.valid}">
                  <span class="col-lg-3">Maximum Angle:</span>
                  <div class="col-lg-2">
                    <input class="form-control" type="text" [formControl]="ringMaxAngle" />
                  </div>
                </div>
                @if (ringMaxAngle.hasError('required')) {
                  <div class="mb-3 row">
                    <div class="col-lg-6 alert alert-danger">
                      Maximum Angle is required
                    </div>
                  </div>
                }
                @if (ringMaxAngle.hasError('minValue') || ringMaxAngle.hasError('maxValue')) {
                  <div
                    class="mb-3 row">
                    <div class="col-lg-6 alert alert-danger">
                      Maximum Angle must be in the range 0 - 999
                    </div>
                  </div>
                }
              </div>
              <div [hidden]="layoutType.value != 'Manual'">
                There are no Manual Layout settings.
              </div>

            </fieldset>
          </form>
        </div>
